var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"nodata-content",staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"200px","height":"100%","margin-top":"38px"},attrs:{"src":require("@/images/undraw_empty_xct9.svg"),"alt":""}}),_c('h6',[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }